import {JsonProperty} from 'json-typescript-mapper';

export class BackofficeMarketdateRangeView {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty('evasiveDate')
  public evasiveDate?: string;

  @JsonProperty('dayString')
  public dayString?: string;

  @JsonProperty('keyword')
  public keyword?: string;

  @JsonProperty('dayString')
  public branchString?: string;


  constructor() {
    this.id = void 0;
    this.status = void 0;
    this.evasiveDate = void 0;
    this.dayString = void 0;
    this.keyword = void 0;
    this.branchString = void 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/backoffice-marketdate-range-view.model.ts